// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UaqO3j{width:42px;height:42px;display:flex;align-items:center;justify-content:center}.UaqO3j .TaF8hq{height:18px;width:100%}div[data-vod-player-max-width~="1900px"] .UaqO3j{width:30px;height:30px}div[data-vod-player-max-width~="1900px"] .UaqO3j .TaF8hq{height:12px;width:100%}div[data-vod-player-max-width~="550px"] .UaqO3j{width:24px;height:24px}div[data-vod-player-max-width~="550px"] .UaqO3j .TaF8hq{height:10px;width:100%}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UaqO3j`,
	"icon": `TaF8hq`
};
export default ___CSS_LOADER_EXPORT___;
